import {
    AddToCartEvent,
    BreachEvent,
    BreachEventProps,
    DataLayerEventName,
} from '@news-mono/web-common'

export function createLinkClickEvent(
    creative: string,
    deal: string,
    onEvent: (event: BreachEvent) => void,
    breachScreenType: BreachEventProps['breachScreenType'] = 'Premium - Inline',
    leadDepth?: number,
    addToCartPayload?: AddToCartEvent['payload'],
): () => void {
    const eventPayload: BreachEvent['payload'] = {
        paywallType: 'freemium',
        leadDepth: leadDepth ?? 0,
        creative: creative,
        breachScreenType,
        popupMethod: 'auto',
        deal: deal,
        pricepoint: [7, 8],
    }

    return () => {
        onEvent({
            type: DataLayerEventName.breachScreenClick,
            originator: 'breachscreen',
            payload: eventPayload,
        })
        // ga4 - `add_to_cart` event
        addToCartPayload &&
            onEvent({
                type: DataLayerEventName.addToCart,
                originator: 'breachscreen',
                payload: addToCartPayload,
            })
    }
}
